import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";

import { ApiService } from "./utilities/api.service";
import { NotificationListConfig } from "../../models";
import { NotificationListResult } from "../../interfaces";

@Injectable()
export class NotificationService {
  constructor(private apiService: ApiService) {}

  public updateOne(notificationId: string) {
    // PUT /api/notifications/:notification/read
    const putURL = `/notifications/${notificationId}/read`;
    return this.apiService.put(putURL);
  }

  public findMany(
    username: string,
    config: NotificationListConfig
  ): Observable<NotificationListResult> {
    let params = {};

    Object.keys(config).forEach((key) => {
      params[key] = config[key];
    });

    // GET /api/profiles/:username/notifications
    const getURL = `/profiles/${username}/notifications`;
    var finalParams = new HttpParams({ fromObject: params });
    return this.apiService.get(getURL, finalParams).pipe(map((data) => data));
  }
}
